export default __webpack_public_path__ + "static/media/awaiting3F.23b26959.svg";